import { BankInterface, BankActionInterface, BankSocketPriority } from "../interfaces/Bank.interface";
import { BLANK_ACTION } from "./action";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_BANK: BankInterface = {
	id: "",
	name: "",
	type: "ELEVATOR",
	channel_id: "",
	server_id: "",
	columns: 0,
	stops: 0,
	number_of_lifts: 0,
	logical_port: 0,
	floor_count: 0,
	floor_below_lobby: 0,
	board: 1,
	rear_doors: false,
	active: true,
	control_panel: "",
	lifts: [],
	offsets: [],
	floor_names: [],
	direct_link: "",
	configurations: [],
	data_blocks: [],
	start_floor_no: 1,
	interface: {},
	bank_floors: [],
	actions: [],
	cmd_binary_control: false,
	socket_message_priority: {
		activeLevel: 1,
		messageTypes: [],
	},
};

export const BLANK_BANK_ACTION: BankActionInterface = {
	id: "",
	toggle_action_id: "",
	action: BLANK_ACTION,
	bank: null,
	toggle_action: BLANK_ACTION,
	color: "#38ac68",
	color2: "#f94d4f",
	button_type: "TOGGLE",
	timer: 1,
	timer2: 1,
	action_id: "",
	bank_id: "",
	created_at: "",
};

export const DEFAULT_MONITORING_PRIORITY: BankSocketPriority = {
	activeLevel: 1,
	messageTypes: [],
};
